<template>
    <div>
      <div 
        @click="launchFile()">
        <slot name="activator"></slot>
      </div>
  
      <input 
        type="file"
        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf"
        ref="file"
        :name="filename"
        v-on:change="changeFile($event.target.files)"
        style="display:none">
  
      <v-dialog 
        v-model="dialog"
        width="500">
        <v-card
          class="pa-0 ma-0"
          flat>
          <v-card
            color="red accent-2">
            <v-list-item>
              <v-list-item-avatar 
                color="red accent-2" 
                size="30">
                <v-icon color="white" large>mdi-alert</v-icon>
              </v-list-item-avatar>
  
              <v-list-item-content>
                <v-card-text 
                  class="caption white--text pa-0">
                  {{ message.error }}
                </v-card-text>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
    export default {
      name: 'upload-document',
      data: () => ({
        dialog: false,
        filename: 'file',
        message: {
          success: '',
          error: ''
        },
        process: {
          form: false
        }
      }),
      methods: {
        launchFile () {
          this.$refs.file.click()
        },
        changeFile (file) {
          let document = file[0]
          if (file.length > 0) {
            if (document.type != 'application/vnd.ms-excel' && document.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && document.type != 'application/pdf') {
              this.dialog = true
              this.message.error = 'Silahkan pilih dokumen dengan format .pdf, .xls, atau .xlsx'
            } else {
              console.log(document)
              let formData = new FormData()
                formData.append('api-key', 'd3f8bfb9d73c9ced96c369186ea2743e')
                formData.append('client-key', 'apikdce584a2be25dd8ae3cc403c3532')
                formData.append('files[]', document)
                formData.append('user_id', this.$store.state.user.id)
                formData.append('file_name', document.name)
  
              this.process.form = true
              this.$emit('input', {
                process: this.process.form
              })
  
              fetch(`https://cdn.klaten.go.id/upload_one/document`, {
                method: 'POST',
                body: formData
              })
              .then(res => res.json())
              .then(response => {
                this.process.form = false
  
                this.$emit('input', {
                  id: response.data[0].id,
                  type: response.data[0].type,
                  data: response.data[0].data,
                  process: this.process.form
                })
              })
            }
          }
        }
      }
    }
  </script>